import { renderPage } from "renderPage"
import { ClubForumSearchPage } from "./Page"

renderPage({ component: ClubForumSearchPage })
